import { getAuthInstance } from "../lib/firebase";
import { DASHBOARD_API_BASE_URL } from "../constants/api";
import { EmailLog } from "./logService";

/**
 * ダッシュボード統計情報
 */
export interface DashboardStats {
  currentMonthCount: number;
  errorCount: number;
  customerCount: number;
  hourlyStats: {
    time: string;
    completed: number;
    warning: number;
    error: number;
    processing: number;
  }[];
}

/**
 * 認証ヘッダーを取得
 */
async function getAuthHeaders(): Promise<HeadersInit> {
  const auth = getAuthInstance();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("認証されていません");
  }

  const token = await user.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
}

/**
 * API エラーをハンドリング
 */
async function handleResponse<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "不明なエラー" }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }
  return response.json();
}

/**
 * ダッシュボード統計情報を取得
 */
export async function fetchDashboardStats(): Promise<DashboardStats> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${DASHBOARD_API_BASE_URL}/stats`, { headers });
  return handleResponse<DashboardStats>(response);
}

/**
 * 直近のエラーログを取得
 */
export async function fetchRecentErrorLogs(): Promise<EmailLog[]> {
  const headers = await getAuthHeaders();
  const response = await fetch(`${DASHBOARD_API_BASE_URL}/recent-errors`, { headers });
  const data = await handleResponse<{ logs: EmailLog[] }>(response);
  return data.logs;
}
